import React from 'react';
import clsx from 'clsx';

type GridListProps<T> = {
  items: T[];
  renderItem: (item: T, index: number) => React.ReactNode;
  columns?: number;
  rows?: number;
  gap?: string;
  className?: string;
  itemClassName?: string;
};

export const GridList = <T,>({
  items,
  renderItem,
  gap = 'gap-4',
  className = '',
  itemClassName = '',
}: GridListProps<T>) => {
  return (
    <div className={clsx('grid', gap, className)}>
      {items.map((item, index) => (
        <div key={index} className={clsx(itemClassName)}>
          {renderItem(item, index)}
        </div>
      ))}
    </div>
  );
};
